var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTensorflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 274,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 274",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m145.726081 42.0651946v42.0695473l72.860871 42.0695701v-42.0695701zm-145.7260812 42.0695473v42.0695701l36.430424 21.030443v-42.065228zm109.2912942 21.0347851-36.4304239 21.034785v126.200004l36.4304239 21.034785v-84.134798l36.434787 21.034785v-42.069548l-36.434787-21.034785z",
    fill: "#e55b2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m145.726081 42.0651946-109.2956572 63.1043324v42.065228l72.8608702-42.065228v42.065228l36.434787-21.030443zm109.295636 21.0347848-36.434765 21.0347625v42.0695701l36.434765-21.034785zm-72.865212 84.1347756-36.430424 21.034785v42.069548l36.430424-21.034785zm-36.430424 63.104333-36.434787-21.034785v84.134798l36.434787-21.034785z",
    fill: "#ed8e24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m145.726081-.00003419-145.7260812 84.13477609 36.430424 21.0347851 109.2956572-63.1043324 72.860871 42.0695473 36.434765-21.0347625zm0 126.20434619-36.434787 21.030443 36.434787 21.034785 36.430424-21.034785z",
    fill: "#f8bf3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensorflow);
export default __webpack_public_path__ + "static/media/tensorflow.eaba86d5ad4676562c01e43bb6e456d4.svg";
export { ForwardRef as ReactComponent };